import { EmblaCarouselType } from 'embla-carousel';
import { Dispatch, SetStateAction } from 'react';

import { useDotButton } from '@/components/Carousel/hooks/useDotButton';
import { DotButton } from '@/components/Carousel/pagination/dotButton';

interface IPaginationProps {
    emblaApi: EmblaCarouselType | undefined,
    setSelectedIndex: Dispatch<SetStateAction<number>>,
    selectedIndex: number;
}

const Pagination = (props: IPaginationProps) => {
    const {
        emblaApi,
        setSelectedIndex,
        selectedIndex,
    } = props;
    const { scrollSnaps, onDotButtonClick } = useDotButton(emblaApi, setSelectedIndex);

    return (
        <div className="flex justify-center items-center gap-2 mt-2.5">
            {scrollSnaps.map((_, index) => (
                <DotButton
                    key={index}
                    aria-label={`To slide ${index + 1}`}
                    onClick={() => onDotButtonClick(index)}
                    className={index === selectedIndex ? 'bg-secondary' : ''}
                />
            ))}
        </div>
    );
};

export default Pagination;
